import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { ThemeStyle } from '@material-ui/core/styles/createTypography';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Gradient } from 'react-gradient';
import { Values } from '../../../../../values/Values';
import Box from '@material-ui/core/Box';
import CardActionArea from '@material-ui/core/CardActionArea';
import { FaTrophy } from 'react-icons/fa'
import DialogDetalhesEstatisticasPessoais from './DialogDetalhesEstatisticasPessoais';
import DialogDetalhesEstatisticasTrap from './DialogDetalhesEstatisticasTrap';




const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 15,
    maxHeight: 160,

  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  titulo: {
    fontWeight: 900,
    color: Values.cores.cinza
  },
  subtitulo01: {
    color: Values.cores.cinza
  },
  subtitulo02: {
    color: Values.cores.cinza
  },
  avatar: {
    height: 64,
    width: 64,
    backgroundColor: Values.cores.branco,
    color: Values.cores.corPrimaria

  },
  icon: {
    height: 32,
    width: 32,
    color: Values.cores.corPrimaria
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));
function CardEstatisticaTrapAmericano(props) {

  const {
    className,
    value,
    filiado,
    dadosDetalhadosEstatisticasTrap,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    ...rest } = props;

  const classes = useStyles();
  const [openDialogDetalhes, setOpenDialogDetalhes] = useState(false);

  function abrirDialogDetalhes(event) {
    setOpenDialogDetalhes(!openDialogDetalhes);
  }

  return (
    <Grid
      container
      className={clsx(classes.root, className)}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <DialogDetalhesEstatisticasTrap
          open={openDialogDetalhes}
          setOpen={setOpenDialogDetalhes}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
          setLoading={setLoading}
          filiado={filiado}
          dados={dadosDetalhadosEstatisticasTrap}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <Box
          boxShadow={10}
          className={clsx(classes.root, className)}
        >
          <Card
            {...rest}
            className={clsx(classes.root, className)}
            variant={'elevation'}
            elevation={10}
          >
            <Gradient
              gradients={ [
                ['#618D71', '#295138'],
              ] } // required
              property="background"
              duration={ 3000 }
              angle="45deg"
            >
              <CardActionArea
                onClick={abrirDialogDetalhes}
              >
                <CardContent>

                  <Grid
                    container
                    justify="space-between"
                    spacing={2}
                  >
                    <Grid
                      item
                    >
                      <Typography
                        className={classes.titulo}
                        gutterBottom
                        variant="body2"
                      >
                        TRAP AMERICANO
                      </Typography>
                      <Typography
                        variant="h2"
                        className={classes.subtitulo01}
                      >
                        {`${value.toFixed(2)}`}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Avatar
                        className={classes.avatar}
                      >
                        <FaTrophy className={classes.icon}/>
                      </Avatar>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                        className={classes.subtitulo02}

                      >
                        {`Quantidade total de disparos realizados, na modalidade Trap Americano, por ${filiado.nome} em toda sua permanência no clube. Para saber
                    mais informações, referente a esse filiado e sua atuação no Trap Americano, basta clicar nesse card.`}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </CardActionArea>
            </Gradient>
          </Card>
        </Box>
      </Grid>

    </Grid>



  );
}

export default CardEstatisticaTrapAmericano;
